import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps {}

export function MarketsDropdown(props: Props) {
	return (
		<FilterDropdown
			{...props}
			id="companyMarketIds"
			values={props.options?.data ?? []}
			objectName="Markets"
			label={props.label ?? "Market"}
			fullLength
			isMulti
		/>
	);
}
